module.exports = __webpack_public_path__ + "img/vertical_4_6_5.678a59e0.png";